import { styled, Box } from '@mui/material';
import { m } from 'framer-motion';
export const HeatingModeCard = styled(Box)({
    height: '100%',
});
export const HeatingModeButton = styled(m.div)(({ small, color }) => ({
    userSelect: 'none',
    width: '100%',
    height: '100%',
    border: `1px solid ${color}`,
    padding: 8,
    position: 'relative',
    display: 'grid',
    gap: 0.5,
    gridTemplateRows: small ? '1fr' : '1fr 1.5fr',
    gridTemplateColumns: small ? '20px 1fr' : '1fr',
    borderRadius: small ? 32 : 12,
    alignItems: 'center',
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
    ':focus': {
        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.6)',
    },
}));
